import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import QRCode from 'qrcode.react';
import Moment from 'react-moment';
import Barcode from '../comum/Barcode';
import moment from 'moment';

export class NotaFiscalCte extends Component {

    exibeCabecalho() {
        return (
            <div className='grid-cteos-container'>
                <div className='div-titulo'>DECLARO QUE RECEBI OS SERVIÇOS DESTE CONHECIMENTO EM PERFEITO ESTADO PELO QUE DOU POR CUMPRIDO O PRESENTE CONTRATO DE TRANSPORTE</div>
                <div className='div-espaco'></div>
                <div className='div-nome'><span className='nome'>NOME:</span></div>
                <div className='div-rg'><span className='rg'>RG:</span></div>
                <div className='div-assinatura'><span className='assinaturaCarimbo'>ASSINATURA/CARIMBO</span></div>
                <div className='div-terminio-prestacao'><span className='terminioPrestacao'>TÉRMINO DA PRESTAÇÃO - DATA/ HORA</span></div>
                <div className='div-inicio-prestacao'><span className='inicioPrestacao'>INICIO DA PRESTAÇÃO - DATA/HORA</span></div>
                <div className='div-cteos'>
                    <div className='subtitulo'>CT-e</div>
                    <div><span className='numero'>N°:</span><span className='numeroValor'>{this.props.encomenda.numeroCte}</span></div>
                    <div><span className='serie'>Série:</span><span className='serieValor'>{this.props.encomenda.serieCte}</span></div>
                </div>
            </div>
        )
    }

    exibeNotaFiscal() {
        return (
            <>
                <hr style={{ borderTop: '2px dashed' }} />
                <div>
                    {this.exibeInicioNotaFiscalParte1()}
                    {this.exibeInicioNotaFiscalParte2()}
                    {this.exibeInformacoesPrestacaoServico()}
                    {this.exibeComponentesValorPrestacaoServico()}
                    {this.exibeInformacoesRelativasImposto()}
                    {this.exibeObservacao()}
                    {this.exibeInformacoesEspecificaDoModalRodoviario()}
                    {this.exibeSeguroVida()}
                </div>
            </>
        )
    }

    exibeBarcode(chaveCte) {
        if (chaveCte) {
            return (
                <React.Fragment>
                    <Barcode value={chaveCte} format="EAN13" />
                </React.Fragment>
            )
        }

        return ''
    }

    exibeQrCode(chaveCte) {
        if (chaveCte) {
            return (
                <QRCode style={{
                    width: 160,
                    height: 160
                }}
                    value={chaveCte} />
            )
        }

        return ''
    }

    exibeInicioNotaFiscalParte1() {
        return (
            <div className='grid-cteos-container-parte-1'>
                <div className='div-espaco-empresa'></div>
                <div className='div-empresa'>
                    <div className='titulo'>{this.props.empresaSelecionada.nomeFantasia}</div>
                    {this.props.empresaSelecionada.endereco ? <div>
                        <div className='endereco'>
                            {this.props.empresaSelecionada.endereco.logradouro} {this.props.empresaSelecionada.endereco.complemento}
                        </div>
                        <div className='cidade'>{this.props.empresaSelecionada.endereco.bairro}, {this.props.empresaSelecionada.endereco.nomeCidade} - {this.props.empresaSelecionada.endereco.uf ? this.props.empresaSelecionada.endereco.uf : ''}</div>
                        <div className='cep'>CEP: {this.props.empresaSelecionada.endereco.cep} Fone: </div>
                        <div className='cnpj'>CNPJ: {this.props.empresaSelecionada.cnpj}</div>
                        <div className='inscricaoEstadual'>Inscrição Estadual: {this.props.empresaSelecionada.inscricaoEstadual}</div>
                    </div> : <div>
                        <div className='endereco'>

                        </div>
                        <div className='cidade'></div>
                        <div className='cep'>CEP:  Fone: </div>
                        <div className='cnpj'>CNPJ: {this.props.empresaSelecionada.cnpj}</div>
                        <div className='inscricaoEstadual'>Inscrição Estadual: {this.props.empresaSelecionada.inscricaoEstadual}</div>
                    </div>}
                </div>
                <div className='div-dacteos'>
                    <div className='titulo'>DACTE OS</div>
                    <div className='subtitulo'>Documento Auxiliar do Conhecimento de Transporte Eletrônico para Outros Serviços</div>
                </div>
                <div className='div-dacteos-codigo-barra'>
                    <div className='campos'>
                        <div className='modelo'><span>MODELO</span> <br />
                            <span>{this.props.encomenda.modelo ? this.props.encomenda.modelo : ''}</span>
                        </div>
                        <div className='serie'><span>SÉRIE</span> <br />
                            <span>{this.props.encomenda.serieCte}</span>
                        </div>
                        <div className='numero'><span>NÚMERO</span> <br />
                            <span>{this.props.encomenda.numeroCte}</span>
                        </div>
                        <div className='folha'><span>FOLHA</span> <br />
                            <span>1/1</span>
                        </div>
                        <div><span>DATA E HORA EMISSÃO</span>  <br />
                            {this.props.encomenda.dataEmissaoCte ? <span><Moment format="DD/MM/YYYY HH:mm">{this.props.encomenda.dataEmissaoCte}</Moment></span> : ''}
                        </div>
                    </div>
                    <div className='dacte-os-codigo'>
                        {this.props.encomenda.ultimoHistoricoEmissaoCte.chaveCte ? this.exibeBarcode(this.props.encomenda.ultimoHistoricoEmissaoCte.chaveCte) : ''}
                    </div>
                    <div className='chaveacesso'><span>Chave de Acesso</span>
                        <p>{this.props.encomenda.ultimoHistoricoEmissaoCte.chaveCte ? this.props.encomenda.ultimoHistoricoEmissaoCte.chaveCte : ''}</p>
                    </div>
                    <div className='linkconsulta'>
                        Consulta de autenticidade no portal nacional do CT-e, no site da Sefaz Autorizadora, ou em http://www.cte.fazenda.gov.br/portal
                    </div>
                </div>
                <div className='div-modal'>
                    <div className='subtitulo'>MODAL</div>
                    <div className='titulo'>RODOVIÁRIO</div>
                </div>
                <div className='div-modal-qrcode'>
                    <p>{this.props.encomenda.ultimoHistoricoEmissaoCte.chaveCte ? this.exibeQrCode(this.props.encomenda.ultimoHistoricoEmissaoCte.urlQRCode) : ''}</p>
                </div>
                <div className='div-tipocte'>
                    <span className='label'>TIPO DO CTE</span>
                    <p>CT-e Normal</p>
                </div>
                <div className='div-tiposervico'>
                    <span className='label'>TIPO DO SERVIÇO</span>
                    <p>{this.props.encomenda.tipoServicoCte.valor}</p>
                </div>
            </div>
        )
    }

    exibeInicioNotaFiscalParte2() {
        return (
            <div className='grid-cteos-container-parte-2'>
                <div className='div-cfop-natureza-operacao'>
                    <span>CFOP - NATUREZA DA OPERAÇÃO</span>
                    <div>{this.props.encomenda.naturezaOperacaoCte.valor}</div>
                </div>
                <div className='div-protocolo-autorizacao-uso'>
                    <span>PROTOCOLO DE AUTORIZAÇÃO DE USO</span>
                    <div></div>
                </div>

                <div className='div-inicio-prestacao'>
                    <span>INICIO DA PRESTAÇÃO</span>
                    <div>{this.props.encomenda.enderecoRemetente.uf}</div>
                </div>
                <div className='div-percurso-veiculo'>
                    <span>PERCURSO DO VEÍCULO</span>
                    <div>{this.props.encomenda.enderecoRemetente.uf == this.props.encomenda.enderecoDestinatario.uf ? this.props.encomenda.enderecoDestinatario.uf : `${this.props.encomenda.enderecoRemetente.uf}-${this.props.encomenda.enderecoDestinatario.uf}`}</div>
                </div>
                <div className='div-terminio-prestacao2'>
                    <span>TERMINO DA PRESTAÇÃO</span>
                    <div>{this.props.encomenda.enderecoDestinatario.uf}</div>
                </div>
                <div className='div-tomador'>
                    <div><span>DESTINATARIO: &nbsp;&nbsp;
                            {<span>{this.props.encomenda.destinatario.nome}</span>}
                        </span>
                        <span>MUNICÍPIO/UF: &nbsp;&nbsp;
                            <span>{`${this.props.encomenda.enderecoDestinatario.localidade}-${this.props.encomenda.enderecoDestinatario.uf}`}</span>
                        </span> <span>PAÍS: BR</span></div>
                    <div><span>ENDEREÇO: {`${this.props.encomenda.enderecoDestinatario.logradouro} ${this.props.encomenda.enderecoDestinatario.bairro} ${this.props.encomenda.enderecoDestinatario.complemento}`}</span> <span>CEP: {this.props.encomenda.enderecoDestinatario.cep}</span></div>
                    <div><span>CPF/CNPJ: {this.props.encomenda.destinatario.cpfCnpj}</span> <span>INSC.EST.: {this.props.encomenda.destinatario.inscEstadual}</span><span>FONE:  {this.props.encomenda.destinatario.telefone}</span> <span>EMAIL: {this.props.encomenda.destinatario.email}</span></div>
                </div>
            </div>
        )
    }

    exibeInformacoesPrestacaoServico() {
        return (
            <>
                <div className='div-titulo-container-p-4'><span>INFORMAÇÕES DA PRESTAÇÃO DO SERVIÇO</span></div>
                <div className='grid-cteos-container-p-4'>
                    <div className='div-quantidade-container-p-4'><span>QUANTIDADE</span> <div>{this.props.encomenda.volume}</div></div>
                    <div className='div-declaracao-servico-prestado-container-p-4'><span>DESCRIÇÃO DO PRODUTO</span>
                        <div>{this.props.encomenda.descricaoProduto}</div>
                    </div>
                </div>
            </>
        )
    }

    exibeComponentesValorPrestacaoServico() {
        return (
            <>
                <div className='div-titulo-componente-container-p-5'>COMPONENTES DO VALOR DA PRESTAÇÃO DE SERVIÇO</div>
                <div className='grid-cteos-container-parte-5'>
                    <div className='div-componente-1-valor-container-p-5'>
                        <div>Nome</div>
                        <div>Valor</div>
                    </div>
                    <div className='div-componente-2-valor-container-p-5'>
                        <div>Nome</div>
                        <div>Valor</div>
                    </div>
                    <div className='div-componente-3-valor-container-p-5'>
                        <div>Nome</div>
                        <div>Valor</div>
                    </div>
                    <div className='div-componente-4-valor-container-p-5'>
                        <div>Nome</div>
                        <div>Valor</div>
                    </div>
                    <div className='div-valor-total-prestacao-servico-container-p-5'>
                        <div>VALOR TOTAL DA PRESTAÇÃO DO SERVIÇO</div>
                        <span>{this.props.encomenda.valorTotal}</span>
                    </div>
                    <div className='div-valor-a-receber-container-p-5'>
                        <div>VALOR A RECEBER</div>
                        <span>0,00</span>
                    </div>
                </div>
            </>
        )
    }

    exibeInformacoesRelativasImposto() {
        return (
            <>
                <div className='div-impostos-titulo'>INFORMAÇÕES RELATIVAS AO IMPOSTO</div>
                <div className='grid-cteos-container-parte-6'>
                    <div className='div-classificacao-tributaria-titulo'>
                        <div>CLASSIFICAÇÃO TRIBUTÁRIA DO SERVIÇO</div>
                        <span>ICMS Simples Nacional</span>
                    </div>
                    <div className='div-classificacao-tributaria-base-caluclo'>
                        <div>BASE DE CÁLCULO</div>
                        <span>{this.props.encomenda.valorTotal}</span>
                    </div>
                    <div className='div-classificacao-tributaria-aliq-icms'>
                        <div>ALIQ. ICMS (%)</div>
                        <span>{this.props.encomenda.aliquotaICMS}</span>
                    </div>
                    <div className='div-classificacao-tributaria-valor-icms'>
                        <div>VALOR ICMS</div>
                        <span>{this.props.encomenda.valorICMS}</span>
                    </div>
                    <div className='div-classificacao-tributaria-red-bc'>
                        <div>% RED.BC.</div>
                        <span>0,00</span>
                    </div>
                    <div className='div-classificacao-tributaria-valor-st'>
                        <div>VALOR ST</div>
                        <span>0,00</span>
                    </div>
                    <div className='div-classificacao-tributaria-valor-inss'>
                        <div>VALOR INSS</div>
                        <span>0,00</span>
                    </div>
                    <div className='div-classificacao-tributaria-valor-pis'>
                        <div>VALOR PIS</div>
                        <span>0,00</span>
                    </div>
                    <div className='div-classificacao-tributaria-valor-cofins'>
                        <div>VALOR COFINS</div>
                        <span>0,00</span>
                    </div>
                    <div className='div-classificacao-tributaria-valor-ir'>
                        <div>VALOR IR</div>
                        <span>0,00</span>
                    </div>
                    <div className='div-classificacao-tributaria-valor-csll'>
                        <div>VALOR CSLL</div>
                        <span>0,00</span>
                    </div>
                </div>
            </>
        )
    }

    exibeObservacao() {
        return (
            <div className='grid-cteos-container-parte-7'>
                <div className='titulo'>OBSERVAÇÕES</div>
                <div className='textarea-observacao'></div>
            </div>
        )
    }

    exibeInformacoesEspecificaDoModalRodoviario() {
        const dataValida = moment(this.props.encomenda.dataHoraPartida, 'DD/MM/YYYY HH:mm', true);
        return (
            <>
                <div className='div-titulo-modal-rodoviario-container-p-8'>
                    INFORMAÇÕES ESPECÍFICAS DO MODAL RODOVIÁRIO
                </div>
                <div className='grid-cteos-container-parte-8'>
                    <div className='div-termo-autorizacao-fretamento-container-p-8'>
                        <div>TERMO DE AUTORIZAÇÃO DE FRETAMENTO</div>
                        <span></span>
                    </div>
                    <div className='div-numero-registro-estadual-container-p-8'>
                        <div>Nº DO REGISTRO ESTADUAL</div>
                        <span></span>
                    </div>
                    <div className='div-placa-veiculo-container-p-8'>
                        <div>PLACA DO VEÍCULO</div>
                        <span></span>
                    </div>
                    <div className='div-renavam-container-p-8'>
                        <div>RENAVAM DO VEÍCULO</div>
                        <span></span>
                    </div>
                    <div className='div-licenciamneto-veiculo-container-p-8'>
                        <div>UF DE LICENCIAMENTO DO VEÍCULO</div>
                        <span></span>
                    </div>
                    <div className='div-cnpj-cpf-container-p-8'>
                        <div>CNPJ/CPF PROPRIETÁRIO</div>
                        <span></span>
                    </div>
                    <div className='div-tipo-fretamento-container-p-8'>
                        <div>TIPO FRETAMENTO</div>
                        <span></span>
                    </div>
                    <div className='div-dt-inicio-viagem-container-p-8'>
                        <div>DATA/HORA INÍCIO VIAGEM</div>
                        <span><Moment format="DD/MM/YYYY HH:mm">{dataValida}</Moment></span>
                    </div>
                </div>
            </>
        )
    }

    exibeSeguroVida() {
        return (
            <React.Fragment className="pagebreak">
                <div className='div-seguro-viagem-continar-p-9'>
                    SEGURO DA VIAGEM
                </div>
                <div className='grid-cteos-container-parte-9'>
                    <div className='div-responsavel-cteos-container-p-9'>
                        <div>RESPONSÁVEL</div>
                        <span></span>
                    </div>
                    <div className='div-nome-seguradora-container-p-9'>
                        <div>NOME DA SEGURADORA</div>
                        <span></span>
                    </div>
                    <div className='div-numero-apolice-container-p-9'>
                        <div>NÚMERO DA APÓLICE</div>
                        <span></span>
                    </div>
                </div>
                <div className='div-area-emissor-e-fisco-container-9'>
                    <div className='div-uso-exclusivo-cteos-container-p-9'>
                        <div>USO EXCLUSIVO DO EMISSOR DO CT-e </div>
                        <div></div>
                    </div>
                    <div className='div-reservado-fisco-container-p-9'>
                        <div>RESERVADO AO FISCO</div>
                        <div></div>
                    </div>
                </div>
            </React.Fragment>
        )
    }

    render() {
        return (
            <div id="notaFiscalCteOs" className="grid invoice">
                <>
                    <div className="grid-body" id='nota-cteos' style={{ boxSizing: 'border-box' }}>
                        {this.exibeCabecalho()}
                        {this.exibeNotaFiscal()}
                    </div>
                </>
            </div>
        )
    }
}

export const mapStateToProps = state => {
    return {
        empresaSelecionada: state.empresaSelecionada,
        encomenda: state.encomenda
    }
};

export default withRouter(connect(mapStateToProps, {})(NotaFiscalCte));
